import Vue from 'vue'
import VueI18n from 'vue-i18n'

import Chinese from './zh'
import ChineseTW from './zh-TW'
import English from './en'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'zh',
  fallbackLocale: 'en',
  messages: {
    zh: Chinese,
    zh_tw: ChineseTW,
    en: English
  }
})
